module.exports = __webpack_public_path__ + "media/3.d225b0fd.mp3";